import { apiHelper } from "../apiHelper/apiHelper";
import {
  getAssignedtasksRequest,
  getAssignedtasksSuccess, getAssignedtasksFailure
} from "../slices/farmerTasksSlices";

// ========================== NEW API HANDLER =================



export const handleGetFarmerTasksList = (userId) => async (dispatch) => {
  const endPoint = `farmertask/${userId}`;
  const method = "GET";
  const state1 = getAssignedtasksRequest;
  const state2 = getAssignedtasksSuccess;
  const state3 = getAssignedtasksFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;

  try {
    const response = await apiHelper(
      endPoint,
      method,
      null,
      state1,
      state2,
      state3,
      dispatch,
      isFile,
      isToast,
      isToken
    );


    // If API response is false, set tasksList to empty
    if (!response) {
      dispatch(getAssignedtasksSuccess([]));
    } 
  } catch (error) {
    console.error("API Error:", error);
    dispatch(getAssignedtasksFailure());
  }
};



// export const handleGetFarmerTasksList = (userId) => async (dispatch) => {
//   const endPoint = `farmertask/${userId}`;
//   const method = "GET";
//   const state1 = getFarmerTasksRequest;
//   const state2 = getFarmerTasksSuccess;
//   const state3 = getFarmerTasksFailure;
//   const isToast = false;
//   const isFile = false;
//   const isToken = true;

//   try {
//     const response = await apiHelper(
//       endPoint,
//       method,
//       null,
//       state1,
//       state2,
//       state3,
//       dispatch,
//       isFile,
//       isToast,
//       isToken
//     );


//     // Ensure assignedTasks array is extracted correctly
//     if (response?.data?.assignedTasks) {
//       dispatch(getFarmerTasksSuccess(response.data.assignedTasks));
//     } else {
//       console.error("Error: assignedTasks not found in response", response);
//       dispatch(getFarmerTasksFailure());
//     }
//   } catch (error) {
//     console.error("API Error:", error);
//     dispatch(getFarmerTasksFailure());
//   }
// };
